
const initState = {
    count:0
}
export default (state=initState,action)=>{
    return state
}